<template>
    <div class="form_box_components">
        <a-form ref="searchRef" :model="form" class="form">
            <template v-for="(item,index) in form_data" :key="index">
                <a-form-item class="form_item_box" :label="item.label" :name="item.name" v-if="item.type == 'input'"
                    :colon="'colon' in item ? item.colon : true">
                    <a-input allowClear v-model:value="form[item.name]"
                        :style="{width : item.width ? item.width : '220px'}" :placeholder="item.placeholder ?? '请输入'">
                    </a-input>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'select'"
                    :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-select allowClear show-search :filterOption="filterOption" ref="select"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model:value="form[item.name]"
                        :style="{width : item.width ? item.width : '220px'}" :placeholder="item.placeholder ?? '请选择'"
                        :options="item.list"></a-select>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'multiple'"
                    :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-select :maxTagCount="1" mode="multiple" allowClear show-search :filterOption="filterOption"
                        ref="select" v-model:value="form[item.name]"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :style="{width : item.width ? item.width : '220px'}" :placeholder="item.placeholder ?? '请选择'"
                        :options="item.list"></a-select>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'cascader'"
                    :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-cascader v-model:value="form[item.name]" :style="{width : item.width ? item.width : '220px'}"
                        :show-search="{ filter }" :placeholder="item.placeholder ?? '请选择'" :options="item.list"
                        :fieldNames="item.fieldNames ? item.fieldNames : {}" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'treeMode'"
                    :name="item.name" :colon="'colon' in item ? item.colon : true">
                    <a-tree-select :treeNodeFilterProp="item.fieldNames?.label" show-search
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :placeholder="item.placeholder ?? '请选择'" v-model:value="form[item.name]" tree-checkable
                        tree-default-expand-all :tree-data="item.list" :show-checked-strategy="SHOW_PARENT"
                        :fieldNames="{value:'id',label:'name',children:'children'}"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :style="{width : item.width ? item.width : '220px'}">
                    </a-tree-select>
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'tree'"
                    :colon="'colon' in item ? item.colon : true">
                    <a-tree-select allow-clear :treeNodeFilterProp="item.fieldNames?.label" show-search
                        v-model:value="form[item.name]" :style="{width : item.width ? item.width : '220px'}"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="item.list"
                        :placeholder="item.placeholder ?? '请选择'" :fieldNames="item.fieldNames ? item.fieldNames : {}" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'treeCity'"
                    :colon="'colon' in item ? item.colon : true">
                    <a-tree-select allow-clear :treeNodeFilterProp="item.fieldNames?.label" show-search
                        v-model:value="form[item.name]" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :style="{width : item.width ? item.width : '220px'}" @change="cityChange($event,item.list,item)"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="item.list"
                        :placeholder="item.placeholder ?? '请选择'" :fieldNames="item.fieldNames ? item.fieldNames : {}" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'time'"
                    :colon="'colon' in item ? item.colon : true">
                    <a-range-picker allowClear v-model:value="form[item.name]"
                        :style="{width : item.width ? item.width : '250px'}" valueFormat="YYYY-MM-DD"
                        format="YYYY-MM-DD" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'date'"
                    :colon="'colon' in item ? item.colon : true">
                    <a-date-picker allowClear v-model:value="form[item.name]" :picker="item.picker ? item.picker : 'date'"
                        :style="{width : item.width ? item.width : '250px'}" :valueFormat="item.format ? item.format : 'YYYY-MM-DD'"
                        :format="item.format ? item.format : 'YYYY-MM-DD'" />
                </a-form-item>
                <a-form-item class="form_item_box" :label="item.label" v-else-if="item.type == 'number'"
                    :colon="'colon' in item ? item.colon : true">
                    <a-input-number :placeholder="item.placeholder ?? '请输入'" :formatter="numberChange"
                        :parser="numberChange" allowClear v-model:value="form[item.name]" :min="1"
                        :style="{width : item.width ? item.width : '220px'}" />
                </a-form-item>

                <template v-else-if="item.type == 'slot'">
                    <slot :name="item.name" :record="item" :form="form"></slot>
                </template>
            </template>
            <a-form-item class="item_btn">
                <a-button type="primary" @click="searh">搜索</a-button>
                <a-button @click="resetting">重置</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
    import {
        TreeSelect
    } from 'ant-design-vue';
    export default {
        props: {
            form_data: {
                type: Object,
                default: []
            },
            tab: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                form: {

                },
                SHOW_PARENT: TreeSelect.SHOW_ALL
            }
        },
        watch: {
            form_data: {
                handler(val, oldVal) {
                    val.forEach(item => {
                        if (item.default || item.default == 0) {
                            this.form[item.name] = item.default
                        }
                    })
                },
                deep: true,
                immediate: true
            }
        },
        created() {

        },
        methods: {
            //搜索
            searh() {
                let form = Object.assign({}, this.form)
                this.form_data.forEach(item => {
                    if (item.type == 'cascader') {
                        if (item.valueType && form[item.name]) {
                            form[item.name] = form[item.name][form[item.name].length - 1]
                        }
                    } else if (item.type == 'time' && form[item.name] && form[item.name].length) {
                        form[item.startTime] = form[item.name][0]
                        form[item.endTime] = form[item.name][1]
                        delete form[item.name]
                    } else if (item.type == 'multiple') {
                        form[item.name] = form[item.name] ? form[item.name].join(',') : ''
                    } else if (item.type == 'treeCity') {
                        delete form[item.name]
                    }
                })
                if (this.tab) {
                    this.$emit('searhcForm', {
                        form,
                        reset: false
                    })
                } else {
                    this.$emit('searhcForm', form)
                }
            },
            //重置
            resetting() {
                this.$refs.searchRef.resetFields()
                this.form = {}
                this.form_data.forEach(item => {
                    if (item.type == 'treeCity') {
                        delete this.form['province']
                        delete this.form['city']
                        delete this.form['district']
                    }
                    if (item.default || item.default == 0) {
                        this.form[item.name] = item.default
                    } else {
                        this.form[item.name] = undefined
                    }
                })
                let form = JSON.parse(JSON.stringify(this.form))
                if (this.tab) {
                    this.$emit('searhcForm', {
                        form,
                        reset: true
                    })
                } else {
                    this.$emit('searhcForm', form)
                }
            },
            // 设置默认值
            setDefaultValue(obj) {
                this.form = Object.assign(this.form, obj)
            },
            //对选择框筛选
            filterOption(input, option) {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // 级联选择框搜索
            filter(inputValue, path) {
                return path.some(option => option.label ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >
                    -1 : option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            },
            //处理数字只能为整数
            numberChange(val) {
                if (typeof val === 'string') {
                    return !isNaN(Number(val)) ? val.replace(/\./g, '') : 0
                } else if (typeof val === 'number') {
                    return !isNaN(val) ? String(val).replace(/\./g, '') : 0
                } else {
                    return 0
                }
            },
            // 城市树选择
            cityChange(val, data, item) {
                let key = item.key ? item.key : 'name'
                let arr = this.$methods.getMenuArrayParent(data, val)
                this.form.province = arr[0] ? arr[0][key] : null
                this.form.city = arr[1] ? arr[1][key] : null
                this.form.district = arr[2] ? arr[2][key] : null
            }
        }
    }
</script>

<style lang="less" scoped>
    .form_box_components {
        .form {
            display: flex;
            flex-flow: row wrap;

            .ant-form-item {
                margin-right: 10px;
                margin-bottom: 15px;
            }

            .item_btn {
                margin-left: 0;
            }

            .ant-btn {
                margin-right: 10px;
            }

        }
    }
</style>